
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 8"}},[_c('path',{attrs:{"d":"M2.517 3.984l2.312-2.418a.516.516 0 0 0 0-.709L4.15.146a.467.467 0 0 0-.679 0L.141 3.629a.519.519 0 0 0 0 .711l3.361 3.513a.466.466 0 0 0 .679 0l.679-.709a.517.517 0 0 0 0-.71l-2.343-2.45z"}}),_c('path',{attrs:{"d":"M9.859 6.434l-2.342-2.45 2.312-2.418a.516.516 0 0 0 0-.709L9.15.146a.467.467 0 0 0-.679 0l-3.33 3.483a.519.519 0 0 0 0 .711l3.361 3.513a.466.466 0 0 0 .679 0l.679-.709a.518.518 0 0 0-.001-.71z"}})])
      }
    
      }
    